//TODO: refactoring this function
const mapStoragesToProducts = (products, storages, storageToProducts) => {
  products.forEach(product => {
    product.isProduct = true
    product.storages = {}
    storages.forEach(storage => {
      product.storages[storage.id] = { ...storage }
      let productStorage = storageToProducts.find(item => {
        return (
          item.product &&
          item.storage &&
          item.product.id === product.id &&
          item.storage.id === storage.id
        )
      })
      product.storages[storage.id].count = productStorage
        ? productStorage.count
        : 0
    })
  })
}
export default mapStoragesToProducts



// WEBPACK FOOTER //
// ./src/modules/productsStorage/services/mapStorageToProducts.js